import { create } from "zustand";
import { EQUIPE_DISPO } from "../Utils/constant";
import { find } from "../services/service";
export const useEquipeStore = create((set) => ({
  loading: false,
  data: [],
  equipePrestataire: [],
  getData: async (date, crenauId) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await find(
        `${EQUIPE_DISPO}?date=${date}&crenauId=${crenauId}`
      );
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
  getEquipePrestataire: async (url) => {
    set({
      loading: true,
      equipePrestataire: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        equipePrestataire: getItems.data.donnee,
      });
    } catch (error) {
      set({
        loading: false,
        equipePrestataire: [],
        error: error?.response?.data?.donnee,
      });
    }
  },
}));
